import { render, staticRenderFns } from "./PersonalCaseDetailsDrawer.vue?vue&type=template&id=f08aef5a"
import script from "./PersonalCaseDetailsDrawer.vue?vue&type=script&lang=js"
export * from "./PersonalCaseDetailsDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports